import {useRouter} from 'next/router';
import {formatToShortAddress} from '@/utils/wallet/formatAddress';
import {usePrivy, useWallets} from '@privy-io/react-auth';

export const useSpoofedWalletAddress = (): string | undefined => {
  const router = useRouter();
  const spoof = router.query.spoof;

  if (Array.isArray(spoof)) {
    return spoof[0];
  }

  return spoof;
};

export const useConnectedWallet = () => {
  const {user, login, logout} = usePrivy();
  const {wallets} = useWallets();

  const spoofedWalletAdress = useSpoofedWalletAddress();
  const connectedAddress = spoofedWalletAdress ?? user?.wallet?.address ?? '';

  return {
    connectedWallet: wallets.filter((w) => w.address === connectedAddress)[0],
    connectWallet: login,
    disconnectWallet: logout,
    connectedAddress,
    formattedConnectedAddress: formatToShortAddress(connectedAddress),
    isConnected: !!connectedAddress,
  };
};
